import RoleService from '../services/RoleService'

const state = () => ({
  loading: false,
  list: []
})

const getters = {
  ROLES_LOADING: state => {
    return state.loading
  },
  ROLES: state => {
    return state.list
  }
}

const mutations = {
  SET_ROLES_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_ROLES: (state, payload) => {
    state.list = payload
  }
}

const actions = {
  LOAD_ROLES: async ({ commit }, filter) => {
    try {
      commit('SET_ROLES_LOADING', true)
      let { data, status } = await RoleService.get(filter)
      if (status === 200) {
        commit('SET_ROLES', data.data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_ROLES_LOADING', false)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
